import ApiConstant from "../../constants/api.constants";
import Helpers from "../../utils/helpers";
import api from "../api";

const tenantGuid = process.env.REACT_APP_TENAT_ID;

const PRODUCTS_CACHE_KEY = "homeProductsCache";
const PRODUCTS_CACHE_TIMESTAMP_KEY = "homeProductsCacheTimestamp";
const CACHE_DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours

let productsCache: any[] | null = null;
let productsPromise: Promise<any[]> | null = null;

const isCacheValid = (): boolean => {
  const timestamp = localStorage.getItem(PRODUCTS_CACHE_TIMESTAMP_KEY);
  return timestamp ? Date.now() - parseInt(timestamp, 10) < CACHE_DURATION_MS : false;
};

const getFromLocalStorage = (): any[] | null => {
  try {
    const cachedData = localStorage.getItem(PRODUCTS_CACHE_KEY);
    if (cachedData) {
      const products: any[] = JSON.parse(cachedData);
      return Array.isArray(products) && products.length > 0 ? products : null;
    }
  } catch (error) {
    clearLocalStorage();
  }
  return null;
};

const saveToLocalStorage = (products: any[]): void => {
  try {
    localStorage.setItem(PRODUCTS_CACHE_KEY, JSON.stringify(products));
    localStorage.setItem(PRODUCTS_CACHE_TIMESTAMP_KEY, Date.now().toString());
  } catch (error) {
    // Silent fail - cache is optional
  }
};

const clearLocalStorage = (): void => {
  localStorage.removeItem(PRODUCTS_CACHE_KEY);
  localStorage.removeItem(PRODUCTS_CACHE_TIMESTAMP_KEY);
};

let currentFetchId = 0;

const fetchProductsFromApi = async (): Promise<any[]> => {
  const fetchId = ++currentFetchId;
  const apiGetProducts = ApiConstant.getHomeProducts + tenantGuid;
  const response = await api.get(apiGetProducts);
  
  if (!response || !response.data) {
    return [];
  }

  if (fetchId !== currentFetchId) {
    return Array.isArray(response.data) ? response.data : [];
  }

  const products = Array.isArray(response.data) ? response.data : [];
  productsCache = products;
  saveToLocalStorage(products);
  
  return products;
};

const fetchProductsFromApi1 = async (): Promise<any[]> => {
  const fetchId = ++currentFetchId;
  const apiGetProducts = ApiConstant.getAllProductsForShipping + tenantGuid;
  const response = await api.get(apiGetProducts);

  if (!response || !response.data) {
    return [];
  }

  if (fetchId !== currentFetchId) {
    return Array.isArray(response.data) ? response.data : [];
  }

  const products = Array.isArray(response.data) ? response.data : [];
  productsCache = products;
  saveToLocalStorage(products);

  return products;
};

const getAllProducts = async () => {
  const apiGetProducts = ApiConstant.getHomeProducts + tenantGuid;
  return await api
    .get(apiGetProducts)
    .then(function (response: any) {
      if (response) {
        return response.data;
      } else {
        return null;
      }
    })
    .catch(function (error: any) {
      console.error("error reading get all categories data.", error);
    });
};


const clearProductCache = (): void => {
  productsCache = null;
  productsPromise = null;
  products1Cache = null;
  products1Promise = null;
  clearLocalStorage();
  localStorage.removeItem(PRODUCTS1_CACHE_KEY);
  localStorage.removeItem(PRODUCTS1_CACHE_TIMESTAMP_KEY);
  localStorage.removeItem(PRODUCTS1_CACHE_KEY); // Redundant if the same but clarified
  localStorage.removeItem(PRODUCTS1_CACHE_TIMESTAMP_KEY);
};


const PRODUCTS1_CACHE_KEY = "homeProducts1Cache";
const PRODUCTS1_CACHE_TIMESTAMP_KEY = "homeProducts1CacheTimestamp";

let products1Cache: any[] | null = null;
let products1Promise: Promise<any[]> | null = null;

const isProducts1CacheValid = (): boolean => {
  const timestamp = localStorage.getItem(PRODUCTS1_CACHE_TIMESTAMP_KEY);
  return timestamp ? Date.now() - parseInt(timestamp, 10) < CACHE_DURATION_MS : false;
};

const getProducts1FromLocalStorage = (): any[] | null => {
  try {
    const cachedData = localStorage.getItem(PRODUCTS1_CACHE_KEY);
    if (cachedData) {
      const products: any[] = JSON.parse(cachedData);
      return Array.isArray(products) && products.length > 0 ? products : null;
    }
  } catch (error) {
    localStorage.removeItem(PRODUCTS1_CACHE_KEY);
    localStorage.removeItem(PRODUCTS1_CACHE_TIMESTAMP_KEY);
  }
  return null;
};

const saveProducts1ToLocalStorage = (products: any[]): void => {
  try {
    localStorage.setItem(PRODUCTS1_CACHE_KEY, JSON.stringify(products));
    localStorage.setItem(PRODUCTS1_CACHE_TIMESTAMP_KEY, Date.now().toString());
  } catch (error) {
    // Silent fail
  }
};

const fetchProducts1FromApi = async (): Promise<any[]> => {
  const apiGetProducts = ApiConstant.getHomeProducts1 + tenantGuid;
  const response = await api.get(apiGetProducts);

  if (!response || !response.data) {
    return [];
  }

  const products = Array.isArray(response.data) ? response.data : [];
  products1Cache = products;
  saveProducts1ToLocalStorage(products);

  return products;
};

const getAllProducts1 = async (forceRefresh: boolean = false): Promise<any[]> => {
  if (!forceRefresh) {
    if (products1Cache) return products1Cache;
    if (isProducts1CacheValid()) {
      const cached = getProducts1FromLocalStorage();
      if (cached) {
        products1Cache = cached;
        return cached;
      }
    } else {
      localStorage.removeItem(PRODUCTS1_CACHE_KEY);
      localStorage.removeItem(PRODUCTS1_CACHE_TIMESTAMP_KEY);
    }

    if (products1Promise) return products1Promise;
  }

  try {
    products1Promise = fetchProducts1FromApi();
    const result = await products1Promise;
    products1Promise = null;
    return result;
  } catch (error) {
    products1Promise = null;
    console.error("[ProductService] API fetch 1 failed:", error);
    return [];
  }
};


const getCategory = async () => {
  return await api
    .get(ApiConstant.getCategory)
    .then(function (response: any) {
      if (response) {
        return response.data;
      } else {
        return null;
      }
    })
    .catch(function (error: any) {
      console.error("error reading get all categories data.", error);
    });
};

const getSubCategory = async () => {
  return await api
    .get(ApiConstant.getSubCategory).then(function (response: any) {
      if (response) {
        return response.data;
      } else {
        return null;
      }
    }).catch(function (error: any) {
      console.error("error reading get all sub categories data.", error)
    })
}

const getAllAdminProducts = async () => {
  const apiGetProducts = ApiConstant.getAllAdminProducts /* + tenantGuid */;
  return await api
    .get(apiGetProducts)
    .then(function (response: any) {
      if (response) {
        return response.data;
      } else {
        return null;
      }
    })
    .catch(function (error: any) {
      console.error("error reading get all categories data.", error);
    });
};


export type ProductPOSQuantitytDTO = {
  posId: number;
  productName: string;
  quantity: number;
  value: number;
  posAlias: string;
};

const getProductPOSQuantity = async (
  productId: number
): Promise<ProductPOSQuantitytDTO[] | null> => {

  const apiGetProductQty = `${ApiConstant.getProductPOSQuantity}/${productId}`;

  return await api
    .get(apiGetProductQty)
    .then(function (response: any) {
      if (response) {
        return response.data as ProductPOSQuantitytDTO[];
      } else {
        return null;
      }
    })
    .catch(function (error: any) {
      console.error("error reading product POS inventory data.", error);
      return null;
    });
};


const saveNewProduct = async (product: any) => {
  debugger;
  return await api
    .post(ApiConstant.saveProduct, product, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}

const saveProduct = async (product: any) => {
  debugger;
  return await api
    .put(ApiConstant.saveProduct, product, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}

const updateProduct = async (product: any) => {
  debugger;

  return await api
    .put(ApiConstant.updateProduct, product, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error) {
      Helpers.ConsoleLog(error, "error");
      return error;
    });
}

const deleteProduct = async (productId: number) => {
  try {
    const productDelete: any = await api
      .delete(ApiConstant.deleteProduct + `?productID=${productId}`)
      .then((res: any) => {
        if (res)
          return res.data;
        else
          return null;
      })
      .catch(function (error: any) {
        console.error('error deleting user.', error);
      });
    const response = productDelete != null ? productId : null;
    return response;
  }
  catch {
    console.log('error in delete user detail');
    return false;
  }
}

const getReorderProductsByOrderId = async (orderId: number) => {
  try {
    const apiUrl = ApiConstant.getReorderProductsByOrderId.replace("{0}", String(orderId));
    const response = await api.get(apiUrl);

    if (response && response.data) {
      return response.data;
    } else {
      console.warn("No data returned for reorder products");
      return null;
    }
  } catch (error) {
    console.error("Error fetching reorder products:", error);
    return null;
  }
};

export const getProductWisePosOpenOrderQty = async (productId: number) => {
  try {
    const result: any = await api
      .get(`${ApiConstant.getproductwisePosOpenorderqty}/${productId}`)
      .then((response: any) => {
        if (response)
          return response.data;
        else
          return null;
      })
      .catch((error: any) => {
        console.error("Error reading POS open order qty.", error);
        return null;
      });

    const responseData = result != null ? result : null;
    return responseData;
  }
  catch (e) {
    console.log("Error in getProductWisePosOpenOrderQty");
    return [];
  }
};

const getProductImageList = async (productId: number) => {
  try {
    const result: any = await api
      .get(ApiConstant.getProductImageList + productId)
      .then((res: any) => {
        if (res) return res.data;
        else return null;
      })
      .catch(function (error: any) {
        console.error("Error fetching product image list.", error);
        return null;
      });
    return result ?? [];
  } catch (e) {
    console.error("Error in getProductImageList", e);
    return [];
  }
};

const getAllProductsForShipping = async (forceRefresh: boolean = false): Promise<any[]> => {
  if (!forceRefresh) {
    // Check in-memory cache
    if (productsCache) {
      return productsCache;
    }

    // Check localStorage cache
    if (isCacheValid()) {
      const cachedProducts = getFromLocalStorage();
      if (cachedProducts) {
        productsCache = cachedProducts;
        return cachedProducts;
      }
    } else {
      clearLocalStorage();
    }

    // Return in-flight request if exists
    if (productsPromise) {
      return productsPromise;
    }
  }

  try {
    productsPromise = fetchProductsFromApi1();
    const result = await productsPromise;
    productsPromise = null;
    return result;
  } catch (error) {
    productsPromise = null;
    console.error("[ProductService] API fetch failed:", error);
    return [];
  }
};

const GetAllProducts = async () => {
  return await api
    .get(ApiConstant.getAllProducts)
    .then(function (response: any) {
      if (response) {
        return response.data;
      } else {
        return null;
      }
    })
    .catch(function (error: any) {
      console.error("error reading get all products data.", error);
    });
};

const ProductService = {
  getAllProducts,
  getCategory,
  getSubCategory,
  getAllAdminProducts,
  getProductPOSQuantity,
  saveNewProduct,
  saveProduct,
  updateProduct,
  deleteProduct,
  getReorderProductsByOrderId,
  getAllProducts1,
  getProductWisePosOpenOrderQty,
  getProductImageList,
  getAllProductsForShipping,
  clearProductCache,
  GetAllProducts,
};

export default ProductService;
